import {PhysicalProperties} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class PhysicalPropertiesModel {
  public shippable: boolean;

  constructor(params: PhysicalPropertiesModel) {
    this.shippable = params.shippable;
  }

  public static fromCartV1({shippable}: {shippable?: boolean}) {
    return new PhysicalPropertiesModel({
      shippable,
    });
  }

  /* istanbul ignore next */
  public static fromCartV2(physicalProperties: PhysicalProperties): PhysicalPropertiesModel {
    return new PhysicalPropertiesModel({
      shippable: physicalProperties.shippable,
    });
  }
}
